import notify from '@/plugins/notify';

import api from '../../helpers/api';
import {
    IUndoState,
    IUndoRequestResponse,
    IUndoApprovalPayload,
    UNDO_STATE_PENDING,
    UNDO_STATE_APPROVED,
    UNDO_STATE_REJECTED,
} from './Undo-types';
import vm from '../../main';

const undoState: IUndoState = {
    state: {
        canRequestUndo: false,
        description: '',
        options: [],
        undoApprovalId: null,
        undoRequestId: null,
        showUndoModal: false,
        submitting: false,
        state: null,
    },
    mutations: {
        setUndoState(state, undoStateResponse: IUndoRequestResponse) {
            state.canRequestUndo = undoStateResponse.canRequestUndo;
            state.state = undoStateResponse.state;
            state.undoRequestId = undoStateResponse.undoRequestId;
        },
        setUndoApprovalInfo(state, options) {
            state.description = options.description;
            state.options = options.options;
            state.undoApprovalId = options.undoApprovalId;
        },
        setShowUndoModal(state, value: boolean) {
            state.showUndoModal = value;
        },
        setSubmitting(state, value: boolean) {
            state.submitting = value;
        },
    },
    actions: {
        async getUndoState({ state, commit, dispatch, getters }, gameId: number) {
            const response = await api.request(`/undo/${gameId}`, 'GET');
            const undoStateResponse: IUndoRequestResponse = await response.json();
            const player = getters.player;
            const { playerId, requiredApprovals } = undoStateResponse;
            const undoStateLabel = undoStateResponse.state;
            let approvalRequired = false;

            if (undoStateLabel === UNDO_STATE_PENDING) {
                if (playerId === player.id) {
                    notify({
                        group: 'undo',
                        clean: true,
                    });

                    notify({
                        group: 'undo',
                        title: 'Please wait...',
                        text: 'Waiting for the other player(s) to approve your request.',
                        duration: -1,
                        data: {
                            spinner: true,
                        },
                    });
                } else {
                    let undoApprovalId;

                    requiredApprovals.map((approval) => {
                        if (approval.playerId === player.id &&
                            approval.state === 'pending') {
                            approvalRequired = true;
                            undoApprovalId = approval.id;
                        }
                    });

                    if (approvalRequired) {
                        await commit('setUndoApprovalInfo', {
                            description: undoStateResponse.description,
                            options: undoStateResponse.options,
                            undoApprovalId,
                        });
                        await commit('setShowUndoModal', true);
                    }
                }
            }

            if (state.state === UNDO_STATE_PENDING) {
                const resolvedUndo = await api.request(`/undo/${state.undoRequestId}/request`, 'GET');
                const resolvedUndoResponse: IUndoRequestResponse = await resolvedUndo.json();

                if (resolvedUndoResponse.state === UNDO_STATE_APPROVED) {
                    notify({
                        group: 'undo',
                        clean: true,
                    });

                    notify({
                        group: 'app',
                        title: 'Success',
                        type: 'success',
                        text: 'The undo request has been approved.',
                    });

                    if (resolvedUndoResponse.playerId !== player.id) {
                        dispatch('resetSelections');
                    }
                }

                if (resolvedUndoResponse.state === UNDO_STATE_REJECTED) {
                    notify({
                        group: 'undo',
                        clean: true,
                    });

                    notify({
                        group: 'app',
                        type: 'error',
                        text: 'The undo request has been denied.',
                    });
                }
            }

            commit('setUndoState', undoStateResponse);
        },
        async requestUndo({ commit, state }, gameId: number) {
            if (state.submitting) {
                return;
            }

            await commit('setSubmitting', true);

            const response = await api.request(`/undo/${gameId}/request`, 'POST');
            const error = await response.json();

            if (!response.ok) {
                notify({
                    group: 'app',
                    clean: true,
                });

                notify({
                    group: 'app',
                    type: 'info',
                    text: error.message,
                });
            }

            await commit('setSubmitting', false);
        },
        async sendDecision({ commit }, payload: IUndoApprovalPayload) {
            const response = await api.request(`/undo/${payload.gameId}/recordDecision`, 'POST', payload);

            if (response.ok) {
                commit('setShowUndoModal', false);
            } else {
                const error = await response.json();

                notify({
                    group: 'app',
                    clean: true,
                });

                notify({
                    group: 'app',
                    type: 'error',
                    text: error.message,
                });

            }
        },
    },
};

export default undoState;
